<template lang="pug">
v-list-item.component-list-item(
  :input-value="isActiveComponent()"
  active-class="sidebar-item--active"
  @click="setActive"
)
  v-list-item-content
    v-list-item-title.tab-label
      | {{ component.title || "[No title]" }}
      span.qty-label(v-if="quantityLabel") &nbsp;{{ quantityLabel }}
  div.item-actions
    v-btn(icon x-small @click.stop="$emit('edit-me')" title="Edit component")
      v-icon(x-small) mdi-pencil
    v-btn(icon x-small @click.stop="$emit('delete-me')" title="Delete component")
      v-icon(x-small color="error") mdi-delete
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    props: {
      component: { required: true }
    },

    mounted() {
      if(this.component.spreadsheetId) {
        this.ensureSheetIndexed(this.component.spreadsheetId)
      }
    },

    computed: {
      ...mapGetters(["activeGame", "activeComponent", "getItemQuantity"]),

      quantityLabel() {
        const quantity = this.getItemQuantity(this.component)
        return quantity > 0 ? `(${quantity})` : ""
      }
    },

    methods: {
      ...mapActions(["ensureSheetIndexed"]),

      setActive() {
        if(this.isActiveComponent()) { return }
        const gameId = this.activeGame.id, componentId = this.component.id
        this.$router.push({ name: 'componentEditor', params: { gameId, componentId } })
      },

      isActiveComponent() {
        return this.component.id === (this.activeComponent && this.activeComponent.id)
      },
    }
  }
</script>

<style scoped>
.component-list-item { cursor: pointer; }
.tab-label {
  font-size: 0.8rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.qty-label {
  color: rgba(128,128,128,0.8);
  font-size: 0.75rem;
}
.item-actions {
  display: flex;
  flex-shrink: 0;
  gap: 2px;
}
</style>
